<main class="main">
  <section class="wrap-title"
    style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/05/Solucoes_1920x324.png'); background-size: cover;">
    <div class="layout">
      <h1 class="title-page">Decisão Certa</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <div class="content">
        <div class="left">
          <div class="ckeditor">
            <p>A Decisão Certa para a sua empresa pode ser a com melhor custo-benefício do mercado! Uma base de dados
              atualizada, que entrega toda a qualidade e segurança que a sua empresa precisa para consultas de
              procedência.</p>
          </div>
          <figure class="fig_mobile">
            <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Decisao-Certa@2x.png">
          </figure>
          <div class="button">
            <a class="btn gradient" href="/decisao-certa">Exemplo da decisão certa</a>
          </div>
        </div>
        <div class="right">
          <figure class="fig">
            <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Decisao-Certa@2x.png">
          </figure>
        </div>
      </div>

      <div class="list-topics">
        <div class="topic">Agregado Veicular</div>
        <div class="topic">Dados Estaduais</div>
        <div class="topic">Dados Nacionais</div>
        <div class="topic">Histórico de Roubo e Furto</div>
        <div class="topic">Veículos ofertados a leilão</div>
        <div class="topic">Leilão complementar</div>
        <div class="topic">Preço de mercado</div>
        <div class="topic">Desvalorização média</div>
        <div class="topic">Dados Históricos VIN-Decode</div>
        <div class="topic">Histórico de Proprietários Anteriores (Base Histórica até julho de 2018)</div>
        <div class="topic">Indício de Sinistro 1 e 2</div>
        <div class="topic">Veículos ofertados a Leilão</div>
        <div class="topic">Localizador de Chassi e Motor</div>
        <div class="topic">Parecer Técnico</div>
        <div class="topic">Histórico de Venda</div>
        <div class="topic">Precificador</div>
      </div>
    </div>
  </section>

  <app-contact-box></app-contact-box>

</main>
